import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  constructor(private router: Router) {}

  private scrollToElement(fragment: string, urlPath: string[]) {
    void this.router.navigate(urlPath, { fragment }).then(() => {
      let requestDemoElement = document.getElementById(fragment);
      if (requestDemoElement !== null) {
        setTimeout(() => {
          // Need to wait for elements to load after navigation before scrolling
          requestDemoElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
        }, 500);
      }
    });
  }

  onScrollToRequestDemo(): void {
    let urlPath = ['/'];
    if (this.router.url.includes('ioip')) urlPath = ['svb', 'ioip'];
    if (this.router.url.includes('spvs')) urlPath = ['svb'];

    this.scrollToElement('request-a-demo', urlPath);
  }

  onScrollToProducts(): void {
    this.scrollToElement('products', ['/']);
  }

  onScrollToFootnote(): void {
    let urlPath = ['/'];

    if (this.router.url.includes('ioip')) urlPath = ['svb', 'ioip'];
    if (this.router.url.includes('spvs')) urlPath = ['svb'];

    this.scrollToElement('svb-footnote', urlPath);
  }
}
